export enum Routes {
  _404 = '/404',
  _500 = '/500',
  __SLUG__BUY = '/[slug]/buy',
  __SLUG__SELL = '/[slug]/sell',
  __SLUG__SPIRITORY = '/[slug]/spiritory',
  __SLUG_ = '/[slug]',
  _ABOUT = '/about',
  _ADMIN_ASKS = '/admin/asks',
  _ADMIN_AUTH__OFFERNUMBER___ID_ = '/admin/auth/[offerNumber]/[id]',
  _ADMIN_AUTH__OFFERNUMBER___ID__REJECT_SOFT = '/admin/auth/[offerNumber]/[id]/reject/soft',
  _ADMIN_AUTH = '/admin/auth',
  _ADMIN_BIDS = '/admin/bids',
  _ADMIN_COUNTRIES = '/admin/countries',
  _ADMIN_COUPONS = '/admin/coupons',
  _ADMIN_FEES = '/admin/fees',
  _ADMIN = '/admin',
  _ADMIN_ORDER__ID_ = '/admin/order/[id]',
  _ADMIN_PARTNERS__ID__EDIT = '/admin/partners/[id]/edit',
  _ADMIN_PARTNERS__ID_ = '/admin/partners/[id]',
  _ADMIN_PARTNERS_ADD = '/admin/partners/add',
  _ADMIN_PARTNERS = '/admin/partners',
  _ADMIN_PARTNERS_USERS__ID_ = '/admin/partners/users/[id]',
  _ADMIN_PROFESSIONAL_SELLERS = '/admin/professional-sellers',
  _ADMIN_REFERRALS_FRIENDS = '/admin/referrals/friends',
  _ADMIN_REFERRALS = '/admin/referrals',
  _ADMIN_REFERRALS_INFLUENCERS = '/admin/referrals/influencers',
  _ADMIN_REFERRALS_SETTINGS = '/admin/referrals/settings',
  _ADMIN_REPORT = '/admin/report',
  _ADMIN_TRANSLATIONS = '/admin/translations',
  _ADMIN_USERS = '/admin/users',
  _API_ACTIVATE_ASK = '/api/activate-ask',
  _API_ACTIVATE_BID = '/api/activate-bid',
  _API_AD_LINK = '/api/ad_link',
  _API_ADD_TO_PORTFOLIO = '/api/add-to-portfolio',
  _API_ADD_WISHLIST = '/api/add-wishlist',
  _API_ADMIN_ALLOW_SHIPPING_POLICY = '/api/admin/allow-shipping-policy',
  _API_ADMIN_APPROVE_AUTH = '/api/admin/approve-auth',
  _API_ADMIN_ASK = '/api/admin/ask',
  _API_ADMIN_ASK_OPEN = '/api/admin/ask/open',
  _API_ADMIN_BID = '/api/admin/bid',
  _API_ADMIN_BID_OPEN = '/api/admin/bid/open',
  _API_ADMIN_COUNTRIES__ID_ = '/api/admin/countries/[id]',
  _API_ADMIN_COUNTRIES = '/api/admin/countries',
  _API_ADMIN_COUPON__ID_ = '/api/admin/coupon/[id]',
  _API_ADMIN_COUPON_CATEGORIES = '/api/admin/coupon/categories',
  _API_ADMIN_COUPON = '/api/admin/coupon',
  _API_ADMIN_DELETE_ASK = '/api/admin/delete-ask',
  _API_ADMIN_DELETE_BID = '/api/admin/delete-bid',
  _API_ADMIN_DISABLE_SELLER = '/api/admin/disable-seller',
  _API_ADMIN_GET_ADMIN_FEES = '/api/admin/get-admin-fees',
  _API_ADMIN_GET_AUTH_IMAGES = '/api/admin/get-auth-images',
  _API_ADMIN_GET_PROFESSIONAL_SELLER_NOTIFICATION = '/api/admin/get-professional-seller-notification',
  _API_ADMIN_GET_PROFESSIONAL_USERS = '/api/admin/get-professional-users',
  _API_ADMIN_GET_REPORT_DATA = '/api/admin/get-report-data',
  _API_ADMIN_GET_SALE = '/api/admin/get-sale',
  _API_ADMIN_GET_SALES = '/api/admin/get-sales',
  _API_ADMIN_GET_STRIPE_BALANCE = '/api/admin/get-stripe-balance',
  _API_ADMIN_MARK_PROFESSIONAL_SELLER_AS_REVIEW = '/api/admin/mark-professional-seller-as-review',
  _API_ADMIN_OFFER__OFFERNUMBER__AUTH__AUTHID__APPROVE = '/api/admin/offer/[offerNumber]/auth/[authId]/approve',
  _API_ADMIN_OFFER__OFFERNUMBER__AUTH__AUTHID__IMAGES = '/api/admin/offer/[offerNumber]/auth/[authId]/images',
  _API_ADMIN_OFFER__OFFERNUMBER__AUTH__AUTHID_ = '/api/admin/offer/[offerNumber]/auth/[authId]',
  _API_ADMIN_OFFER__OFFERNUMBER__AUTH__AUTHID__REASONS = '/api/admin/offer/[offerNumber]/auth/[authId]/reasons',
  _API_ADMIN_OFFER__OFFERNUMBER__AUTH__AUTHID__REJECT_FINAL = '/api/admin/offer/[offerNumber]/auth/[authId]/reject/final',
  _API_ADMIN_OFFER__OFFERNUMBER__AUTH__AUTHID__REJECT_SOFT = '/api/admin/offer/[offerNumber]/auth/[authId]/reject/soft',
  _API_ADMIN_ORDER__ID__PAYVALUE = '/api/admin/order/[id]/payvalue',
  _API_ADMIN_ORDER__ID_ = '/api/admin/order/[id]',
  _API_ADMIN_PARTNERS__ID_ = '/api/admin/partners/[id]',
  _API_ADMIN_PARTNERS_ALL = '/api/admin/partners/all',
  _API_ADMIN_PARTNERS = '/api/admin/partners',
  _API_ADMIN_PARTNERS_USERS__ID_ = '/api/admin/partners/users/[id]',
  _API_ADMIN_REFERRALS_FRIENDS = '/api/admin/referrals/friends',
  _API_ADMIN_REFERRALS = '/api/admin/referrals',
  _API_ADMIN_REFERRALS_INFLUENCERS = '/api/admin/referrals/influencers',
  _API_ADMIN_REFERRALS_OVERVIEW = '/api/admin/referrals/overview',
  _API_ADMIN_REFERRALS_SETTINGS__ID_ = '/api/admin/referrals/settings/[id]',
  _API_ADMIN_REFERRALS_SETTINGS = '/api/admin/referrals/settings',
  _API_ADMIN_SALES__ID__FORCE_PAYOUT = '/api/admin/sales/[id]/force-payout',
  _API_ADMIN_SALES__ID_ = '/api/admin/sales/[id]',
  _API_ADMIN_SALES__ID__STATUSES_RECEIVEDBYTIMEOUT = '/api/admin/sales/[id]/statuses/receivedByTimeout',
  _API_ADMIN_SALES__ID__UNMATCH = '/api/admin/sales/[id]/unmatch',
  _API_ADMIN_SALES = '/api/admin/sales',
  _API_ADMIN_SALES_PAYOUT = '/api/admin/sales/payout',
  _API_ADMIN_STRIPE_INTENT__ID_ = '/api/admin/stripe/intent/[id]',
  _API_ADMIN_TRANSLATIONS_CREATION_DATA = '/api/admin/translations/creation-data',
  _API_ADMIN_TRANSLATIONS = '/api/admin/translations',
  _API_ADMIN_TRIGGER_PAYOUT = '/api/admin/trigger-payout',
  _API_ADMIN_UNMATCH_ORDER = '/api/admin/unmatch-order',
  _API_ADMIN_UPDATE_FEE = '/api/admin/update-fee',
  _API_ADMIN_USER__ID_ = '/api/admin/user/[id]',
  _API_ADMIN_USER = '/api/admin/user',
  _API_APP_DOWNLOAD = '/api/app/download',
  _API_ASK__ID_ = '/api/ask/[id]',
  _API_ASK_ALL = '/api/ask/all',
  _API_ASK = '/api/ask',
  _API_ASK_PAGINATED = '/api/ask/paginated',
  _API_AUTH_CALLBACK_SIGN_IN = '/api/auth/callback/sign-in',
  _API_AUTH_CALLBACK_SIGN_UP = '/api/auth/callback/sign-up',
  _API_AUTH_LOGOUT = '/api/auth/logout',
  _API_AUTH_RESET_PASSWORD = '/api/auth/reset-password',
  _API_AUTH_RESET_PASSWORD_SEND = '/api/auth/reset-password/send',
  _API_AUTH_RESET_PASSWORD_SEND_WITH_AUTH = '/api/auth/reset-password/send/with-auth',
  _API_AUTH_SESSION = '/api/auth/session',
  _API_AUTH_SIGN_IN_CREDENTIALS = '/api/auth/sign-in/credentials',
  _API_AUTH_SIGN_IN_SOCIAL__PROVIDER_ = '/api/auth/sign-in/social/[provider]',
  _API_AUTH_SIGN_UP_CREDENTIALS_EMAIL_VERIFICATION = '/api/auth/sign-up/credentials/email-verification',
  _API_AUTH_SIGN_UP_CREDENTIALS_EMAIL_VERIFICATION_RESEND = '/api/auth/sign-up/credentials/email-verification/resend',
  _API_AUTH_SIGN_UP_CREDENTIALS = '/api/auth/sign-up/credentials',
  _API_AUTH_SIGN_UP_SOCIAL__PROVIDER_ = '/api/auth/sign-up/social/[provider]',
  _API_AUTH_SIGN_UP_TOKEN = '/api/auth/sign-up/token',
  _API_AUTH_TOKEN_REFRESH = '/api/auth/token/refresh',
  _API_BID__ID_ = '/api/bid/[id]',
  _API_BID_ALL = '/api/bid/all',
  _API_BID = '/api/bid',
  _API_BID_PAGINATED = '/api/bid/paginated',
  _API_BLOG_ALL = '/api/blog/all',
  _API_BLOG_DOCUMENTID__DOCUMENTID_ = '/api/blog/documentId/[documentId]',
  _API_BLOG = '/api/blog',
  _API_BLOG_SLUG__SLUG_ = '/api/blog/slug/[slug]',
  _API_BRAND_POPULAR = '/api/brand/popular',
  _API_CHANGE_LANGUAGE = '/api/change-language',
  _API_CHANGE_PASSWORD = '/api/change-password',
  _API_COLLECTION__ID_ = '/api/collection/[id]',
  _API_COLLECTION_DOCUMENTID__DOCUMENTID_ = '/api/collection/documentId/[documentId]',
  _API_COLLECTION = '/api/collection',
  _API_CONTACT_US = '/api/contact-us',
  _API_CONTACT = '/api/contact',
  _API_CREATE_ASK = '/api/create-ask',
  _API_CREATE_AUTH = '/api/create-auth',
  _API_CREATE_BID = '/api/create-bid',
  _API_CREATE_SHIPPING = '/api/create-shipping',
  _API_CREATE_STRIPE_USER = '/api/create-stripe-user',
  _API_CREATE_TRACKING = '/api/create-tracking',
  _API_CREATE_USER_PROFILE_V2 = '/api/create-user-profile-v2',
  _API_CREATE_USER = '/api/create-user',
  _API_CRYPTO_DECRYPT_ROUTE = '/api/crypto/decrypt/route',
  _API_CRYPTO_ENCRYPT_ROUTE = '/api/crypto/encrypt/route',
  _API_DASHBOARD_ASK_ALL = '/api/dashboard/ask/all',
  _API_DASHBOARD_BID_ALL = '/api/dashboard/bid/all',
  _API_DASHBOARD_OFFERS_ALL = '/api/dashboard/offers/all',
  _API_DASHBOARD_OFFERS_SKU_ORDER_STATUS__ID__RETRY_SHIPPING = '/api/dashboard/offers/sku-order-status/[id]/retry-shipping',
  _API_DELETE_ASK = '/api/delete-ask',
  _API_DELETE_BID = '/api/delete-bid',
  _API_DELETE_FROM_WISHLIST = '/api/delete-from-wishlist',
  _API_DELETE_PAYMENT_METHOD = '/api/delete-payment-method',
  _API_DELETE_PORTFOLIO = '/api/delete-portfolio',
  _API_EXTEND_ASK = '/api/extend-ask',
  _API_EXTEND_BID = '/api/extend-bid',
  _API_FEEDBACK = '/api/feedback',
  _API_FEES = '/api/fees',
  _API_FESTIVAL_WHISKYFESTIVAL = '/api/festival/Whiskyfestival',
  _API_FESTIVAL_VOUCHER = '/api/festival-voucher',
  _API_GET_ASKS = '/api/get-asks',
  _API_GET_AUTH_IMAGES = '/api/get-auth-images',
  _API_GET_BIDS = '/api/get-bids',
  _API_GET_BILL = '/api/get-bill',
  _API_GET_BOTTLE_OF_THE_DAY = '/api/get-bottle-of-the-day',
  _API_GET_CTA_COUNT = '/api/get-cta-count',
  _API_GET_DASHBOARD_LAST_ACTIVITY = '/api/get-dashboard-last-activity',
  _API_GET_DHL = '/api/get-dhl',
  _API_GET_FEES = '/api/get-fees',
  _API_GET_IS_PROFESSIONAL = '/api/get-is-professional',
  _API_GET_LAST_ACTIVITIES_PER_SKU = '/api/get-last-activities-per-sku',
  _API_GET_LAST_ACTIVITIES = '/api/get-last-activities',
  _API_GET_MANAGEMENTAPI_TOKEN = '/api/get-managementApi-token',
  _API_GET_MOST_POPULAR = '/api/get-most-popular',
  _API_GET_MOST_WATCHED = '/api/get-most-watched',
  _API_GET_NEW_SKUS = '/api/get-new-skus',
  _API_GET_NOTIFICATION_COUNT = '/api/get-notification-count',
  _API_GET_NOTIFICATIONS = '/api/get-notifications',
  _API_GET_OFFER = '/api/get-offer',
  _API_GET_OFFERS = '/api/get-offers',
  _API_GET_ORDER = '/api/get-order',
  _API_GET_ORDERS = '/api/get-orders',
  _API_GET_POPULAR_BRANDS = '/api/get-popular-brands',
  _API_GET_PORTFOLIO = '/api/get-portfolio',
  _API_GET_PROFESSIONAL_SELLERS_COUNTRIES = '/api/get-professional-sellers-countries',
  _API_GET_PROFIT_LOSS_CHART = '/api/get-profit-loss-chart',
  _API_GET_RECOMMENDED_SKUS = '/api/get-recommended-skus',
  _API_GET_SHIPMENT = '/api/get-shipment',
  _API_GET_SIMILAR_PRODUCTS = '/api/get-similar-products',
  _API_GET_SKU_WITH_PARAMS = '/api/get-sku-with-params',
  _API_GET_TOP_PROFIT = '/api/get-top-profit',
  _API_GET_TOP_SELLERS = '/api/get-top-sellers',
  _API_GET_USER = '/api/get-user',
  _API_GET_VALUE_PIE_CHART = '/api/get-value-pie-chart',
  _API_GET_WISHLIST_SKUS = '/api/get-wishlist-skus',
  _API_GET_WISHLIST = '/api/get-wishlist',
  _API_GOOGLE_REVIEWS = '/api/google-reviews',
  _API_LANGUAGE = '/api/language',
  _API_LIMITED_SPECIAL_OFFER = '/api/limited-special-offer',
  _API_NEWSLETTER = '/api/newsletter',
  _API_NOTIFICATIONS_SETTINGS = '/api/notifications/settings',
  _API_ORDER_BID__ID_ = '/api/order/bid/[id]',
  _API_ORDER_RECEIVED = '/api/order-received',
  _API_PAUSE_ASK = '/api/pause-ask',
  _API_PAUSE_BID = '/api/pause-bid',
  _API_PAYMENT_INTENT__ID__COUPON = '/api/payment/intent/[id]/coupon',
  _API_PAYMENT_INTENT__ID_ = '/api/payment/intent/[id]',
  _API_PAYMENT_INTENT = '/api/payment-intent',
  _API_PAYMENT_METHODS = '/api/payment-methods',
  _API_PORTFOLIO_CHANGE = '/api/portfolio/change',
  _API_PORTFOLIO = '/api/portfolio',
  _API_PRESS_RELEASE_SUBSCRIPTION = '/api/press/release-subscription',
  _API_PROFESSIONAL_SELLER = '/api/professional-seller',
  _API_QR_CODE_FOOTER = '/api/qr-code/footer',
  _API_READ_NOTIFICATION = '/api/read-notification',
  _API_REDIRECTTO = '/api/redirectTo',
  _API_REFERRALS__CODE_ = '/api/referrals/[code]',
  _API_REFERRALS__CODE__PRE_REDEEM = '/api/referrals/[code]/pre-redeem',
  _API_REFERRALS__CODE__REDEEM = '/api/referrals/[code]/redeem',
  _API_SET_NOTIFICATIONS_READED = '/api/set-notifications-readed',
  _API_SETUP_INTENT = '/api/setup-intent',
  _API_SKU__SLUG__ASKS = '/api/sku/[slug]/asks',
  _API_SKU__SLUG__BIDS = '/api/sku/[slug]/bids',
  _API_SKU__SLUG__BIDS_ASKS = '/api/sku/[slug]/bids-asks',
  _API_SKU__SLUG__DATA = '/api/sku/[slug]/data',
  _API_SKU__SLUG__ID = '/api/sku/[slug]/id',
  _API_SKU__SLUG_ = '/api/sku/[slug]',
  _API_SKU__SLUG__ORDERS = '/api/sku/[slug]/orders',
  _API_SKU__SLUG__WITH_PARAMS_DATA = '/api/sku/[slug]/with-params/data',
  _API_SKU__SLUG__WITH_PARAMS = '/api/sku/[slug]/with-params',
  _API_SKU_LAST_VIEWED = '/api/sku/last-viewed',
  _API_SKU_MOST_POPULAR_AROUND_YOU = '/api/sku/most-popular-around-you',
  _API_SKU_MULTIPLE = '/api/sku/multiple',
  _API_SKU_RELEASE_CALENDAR = '/api/sku/release-calendar',
  _API_STRAPI_BRANDS = '/api/strapi/brands',
  _API_STRAPI_SKU_SLUG__SLUG_ = '/api/strapi/sku/slug/[slug]',
  _API_STRIPE_PAYMENT_METHOD = '/api/stripe/payment-method',
  _API_STRIPE_SETUP_INTENT = '/api/stripe/setup-intent',
  _API_SUGGEST_BOTTLE = '/api/suggest-bottle',
  _API_TRACKING = '/api/tracking',
  _API_TRACKING_SKUS_BATCH_TRACK_VIEWS = '/api/tracking/skus/batch-track-views',
  _API_TRACKING_SKUS_ID__ID__TRACK_VIEW = '/api/tracking/skus/id/[id]/track-view',
  _API_TRACKING_SKUS_ID__ID__VIEWS_STATS = '/api/tracking/skus/id/[id]/views-stats',
  _API_TRACKING_SKUS_SLUG__SLUG_ = '/api/tracking/skus/slug/[slug]',
  _API_TRACKING_SKUS_SLUG__SLUG__VIEWS_STATS = '/api/tracking/skus/slug/[slug]/views-stats',
  _API_TRACKING_SKUS_USER_VIEWS = '/api/tracking/skus/user-views',
  _API_UPDATE_ALLOWED_COUNTRIES = '/api/update-allowed-countries',
  _API_UPDATE_AUTH_IMAGES = '/api/update-auth-images',
  _API_UPDATE_BID_ASK_VALUE = '/api/update-bid-ask-value',
  _API_UPDATE_PORTFOLIO = '/api/update-portfolio',
  _API_UPDATE_SHIPPING_ADDRESS = '/api/update-shipping-address',
  _API_UPDATE_SHIPPING = '/api/update-shipping',
  _API_UPDATE_TRACKING = '/api/update-tracking',
  _API_UPLOAD_AUTH_IMAGES = '/api/upload-auth-images',
  _API_USER_ACCOUNT_NUMBER = '/api/user/account-number',
  _API_USER_DELETE = '/api/user/delete',
  _API_USER_PROFESSIONAL_TYPE = '/api/user/professional/type',
  _API_USER_REFERRALS_CODE = '/api/user/referrals/code',
  _API_USER_REFERRALS = '/api/user/referrals',
  _API_USER_REFERRALS_REWARDS = '/api/user/referrals/rewards',
  _API_USER_SELLER = '/api/user/seller',
  _API_USER_SHIPPING_ADDRESS = '/api/user/shipping-address',
  _API_USER_TAX_NUMBER = '/api/user/tax-number',
  _API_UTILS_COUNTRY = '/api/utils/country',
  _API_WISHLIST__ID_ = '/api/wishlist/[id]',
  _API_WISHLIST = '/api/wishlist',
  _AUTH_FORGOT_PASSWORD = '/auth/forgot-password',
  _AUTH_LOGOUT = '/auth/logout',
  _AUTH_ONBOARDING_BUYER__SLUG_ = '/auth/onboarding/buyer/[...slug]',
  _AUTH_ONBOARDING = '/auth/onboarding',
  _AUTH_ONBOARDING_SELLER__SLUG_ = '/auth/onboarding/seller/[...slug]',
  _AUTH_RESET_PASSWORD = '/auth/reset-password',
  _AUTH_SIGN_IN = '/auth/sign-in',
  _AUTH_SIGN_UP = '/auth/sign-up',
  _AUTH_VERIFY_EMAIL = '/auth/verify-email',
  _AUTHENTICATING = '/authenticating',
  _BLOG__SLUG_ = '/blog/[slug]',
  _BLOG_AUTHORS__SLUG_ = '/blog/authors/[slug]',
  _BLOG_AUTHORS = '/blog/authors',
  _BLOG = '/blog',
  _BRANDS___SKUS__ = '/brands/[[...skus]]',
  _BUYER_GUIDE = '/buyer-guide',
  _BUYING_LIMITED_OFFER = '/buying_limited_offer',
  _CATEGORY___SKUS__ = '/category/[[...skus]]',
  _COLLECTIONS__SLUG_ = '/collections/[slug]',
  _COLLECTIONS = '/collections',
  _CONDITION_GUIDE = '/condition-guide',
  _COOKIE_POLICY = '/cookie-policy',
  _COUNTRY___SKUS__ = '/country/[[...skus]]',
  _CURATION___SKUS__ = '/curation/[[...skus]]',
  _DASHBOARD_BUYING = '/dashboard/buying',
  _DASHBOARD_EDIT_ASK__SLUG___ID_ = '/dashboard/edit/ask/[slug]/[id]',
  _DASHBOARD_EDIT_BID__SLUG___ID_ = '/dashboard/edit/bid/[slug]/[id]',
  _DASHBOARD = '/dashboard',
  _DASHBOARD_LAST_VIEWED = '/dashboard/last-viewed',
  _DASHBOARD_NOTIFICATIONS = '/dashboard/notifications',
  _DASHBOARD_OFFER_AUTH__OFFERNUMBER_ = '/dashboard/offer-auth/[...offerNumber]',
  _DASHBOARD_PAY__ORDERNUMBER_ = '/dashboard/pay/[orderNumber]',
  _DASHBOARD_PORTFOLIO = '/dashboard/portfolio',
  _DASHBOARD_REFERRALS = '/dashboard/referrals',
  _DASHBOARD_SELLING = '/dashboard/selling',
  _DASHBOARD_SETTINGS_BUYER_PROFILE_BUSINESS = '/dashboard/settings/buyer-profile/business',
  _DASHBOARD_SETTINGS_BUYER_PROFILE = '/dashboard/settings/buyer-profile',
  _DASHBOARD_SETTINGS_FEEDBACK = '/dashboard/settings/feedback',
  _DASHBOARD_SETTINGS = '/dashboard/settings',
  _DASHBOARD_SETTINGS_SELLER_PROFILE_BECOME_A_SELLER = '/dashboard/settings/seller-profile/become-a-seller',
  _DASHBOARD_SETTINGS_SELLER_PROFILE = '/dashboard/settings/seller-profile',
  _DASHBOARD_SETTINGS_SELLER_PROFILE_PROFESSIONAL = '/dashboard/settings/seller-profile/professional',
  _DASHBOARD_SETTINGS_SERVICES = '/dashboard/settings/services',
  _DASHBOARD_SUGGEST_BOTTLE = '/dashboard/suggest-bottle',
  _DASHBOARD_TRACKINGS = '/dashboard/trackings',
  _DASHBOARD_WISHLIST = '/dashboard/wishlist',
  _DATA_PRIVACY = '/data-privacy',
  _GOOGLE6B7F63C7FABCF52FHTML = '/google6b7f63c7fabcf52f.html',
  _HELP = '/help',
  _HIGHLIGHTS___SKUS__ = '/highlights/[[...skus]]',
  _HOW_IT_WORKS = '/how-it-works',
  _IMPRINT = '/imprint',
  _INVESTOR = '/investor',
  _JOBS = '/jobs',
  _MAINTENANCE = '/maintenance',
  _PORTFOLIO_GUIDE = '/portfolio-guide',
  _PRESS = '/press',
  _REGION___SKUS__ = '/region/[[...skus]]',
  _SEARCH___SKUS__ = '/search/[[...skus]]',
  _SELECTION___SKUS__ = '/selection/[[...skus]]',
  _SELLER_GUIDE = '/seller-guide',
  _SELLING_LIMITED_OFFER = '/selling_limited_offer',
  _SHIPPING_GUIDE = '/shipping-guide',
  _SIGN_UP_FB_AD = '/sign_up_fb_ad',
  _SITEMAPTXT = '/sitemap.txt',
  _SITEMAPS_BLOG__PAGE__SITEMAPXML = '/sitemaps/blog/[page]/sitemap.xml',
  _SITEMAPS_BLOG_FEED__LOCALE__FEEDXML = '/sitemaps/blog/feed/[locale]/feed.xml',
  _SITEMAPS_COLLECTION__PAGE__SITEMAPXML = '/sitemaps/collection/[page]/sitemap.xml',
  _SITEMAPS_SKU__PAGE__SITEMAPXML = '/sitemaps/sku/[page]/sitemap.xml',
  _SITEMAPS_STATIC_SITEMAPXML = '/sitemaps/static/sitemap.xml',
  _SKU__SLUG_ = '/sku/[slug]',
  _SPECIAL_OFFER = '/special_offer',
  _SUBCATEGORIES___SKUS__ = '/subcategories/[[...skus]]',
  _TERMS = '/terms',
}
